class Access_deniedController {
  /*@ngInject*/
  constructor(Auth, $state, User, UserService) {
    this.Auth = Auth
    this.$state = $state
    this.User = User
    this.message = ''
  }


}


export default Access_deniedController;


// WEBPACK FOOTER //
// ./client/app/components/access_denied/access_denied.controller.js